import TableCSVExporter from '@/plugins/tabletocsv'
import {
    mapMutations
  } from 'vuex'
export const API_MIXINS = {
    methods: {
        ...mapMutations([
            'setAlert',
            'setAlertColor', 
            'setAlertText',
            'setGameSetting',
            'setOverlay',
            'setAllowStatBox',
            'setAllowSetUp',
            'setAdmin',
            'setAccountTransactions',
            'setProductStatus',
            'setSysVars',
            'setInfoDrawer',
            'setActionAlert'
        ]),

       PrintInvoice(href) {
         
          const win = window.open(href, "_blank");

          win.onload = () => {
            win.print();
          };
        }, 
        CHECKPAGEPERMISSION(){
          if(!this.VALIDATEPAGEACCESS()) {
              this.$router.push('/dashboard')
          }
        },
        VALIDATEPAGEACCESS(){
            if(this.$route.path == '/dashboard'){return true}
            if(this.IS_ADMIN()){return true}
            var menus  = this.MYMENUS()
             for(var i=0; i<menus.length;i++) {
              if(this.$route.path == menus[i].page) {
                return true
              }
            }
            return false
        },
        MYMENUS() {
     
        var account = this.$session.get("account")
        var menus = account.page_permissions.reduce((res, item)=>{
         
            for(var i=0; i<this.$store.state.staff_menus.length;i++) {
              if(this.$store.state.staff_menus[i].title.trim() == item.trim()) {
               if(this.$store.state.staff_menus[i].show) {
                  res.push(this.$store.state.staff_menus[i])
                }
              }
            }
            return res
        }, [])
        return menus
      },
      ALLOWEDACTION(req_action) {
         if(this.IS_ADMIN()){return true}
        var account = this.$session.get("account")
        var actions = account.action_permissions
        if(this.IsEmpty(actions)) {return false}
          for(var i=0; i<actions.length;i++) {
              if(req_action == actions[i]) {
                return true
              }
          }
        return false
      },
      IS_ADMIN(){
        if(this.$session.get('role') == 'Administrator') {
          return true
        } return false
      },
        INFO(){
          this.setInfoDrawer(true)
        },
        Track(track){
          if(track =='Track Inventory') {
            return true
          } return false
         },
         IsEmpty(value){
         
          if(value == null || value == "" || value == undefined) {
            return true
          } 
          return false
        },
        VA_ALERT(type, message, icon, timein, timeout) {
          setTimeout(()=>{
            this.setActionAlert({show: true, text: message, type:type, icon: icon});
           }, timein)
           this.ClearSnackbar(timeout+timein)
        },
       
        GET_SYSVARS(var_name){
            let _arr = this.$store.state.sys_vars
            let variable = _arr.find(_var => _var.name === var_name);
            if(variable.data_type=='array') {
              let _arrVal = variable.value.split(',')
              return _arrVal
            } else if(variable.data_type=='string') {
                return variable.value
            } else {
               return variable.value
            }
        },
        SETVARS(){
         // if(!this.$store.state.sys_vars) {
            // this.QUERY('variables','select * from variables', (res)=>{
            //   this.setSysVars(res.results)
            //   console.log(res.results)
            // })
          //}
          this.$http.get("get_vars").then(res => {
       
            this.setSysVars(res.data.results)
            
         
        }).catch(e => {
          console.log(e.data)
        })
          
        },
        GET_PRODUCTS(callback){
        
          this.QUERY('products','select * from products order by id desc', (res)=>{
            callback(res)
          })
        },
        SINGLE_PRODUCT(productID, callback){
          this.QUERY('products','select * from products where id='+productID+' order by id desc', (res)=>{
            console.log(res)
            callback(res)
          })
        },
        GET_PRODUCT_ITEMS(productID, callback){
          this.QUERY('product_items','select * from product_items where product_id='+productID+' order by id desc', (res)=>{
            console.log(res)
            callback(res)
          })
        },
        GET_VENDORS(callback){
          this.QUERY('vendors','select * from vendors order by id desc', (res)=>{
            console.log(res)
            callback(res)
          })
        },

        GET_COST(from_date,to_date,callback){
            let params = {
                table: "sales_item", 
                query: `select i.* from sales_items i left join sales s on s.id=i.sales_id
where s.payment_status = 'Paid' and (s.status='Completed' or s.status='Active')  and to_date(s.created_at::text,'YYYY-MM-DD')>='${from_date}' and to_date(s.created_at::text,'YYYY-MM-DD')<='${to_date}' `,
                type:"query"
            }
      
          this.$http.post("query",params).then(response => {
              callback(response.data)
          }).catch(e => {
            console.log(e.data)
          })
          
      },
       GET_COST_INSTALLMENT(from_date,to_date,callback){
            let params = {
                table: "sales_item", 
                query: `select sum(cost) as total from sales_items i left join sales s on s.id=i.sales_id where to_date(created_at::text,'YYYY-MM-DD') >= '${from_date}'
and to_date(created_at::text,'YYYY-MM-DD') <= '${to_date}' and (status = 'Active' or status='Completed') `,
                type:"query"
            }
      
          this.$http.post("query",params).then(response => {
              callback(response.data)
          }).catch(e => {
            console.log(e.data)
          })
          
      },

        QUERY(_model,_qry_str,callback){
            let params = {
                table: _model, 
                query: _qry_str,
                type:"query"
            }
          this.$http.post("query",params).then(response => {
              callback(response.data)
          }).catch(e => {
            console.log(e.data)
          })
          
      },
        Strip(text) {
      var uptext = text.replace(/<[^>]*>/g, "");
      return uptext.trim()
    },
      STATUS_COLOR(status){
         switch(status) {
            case "Available":
              return "success"
            case "Pending":
              return "warning"
              case "Completed":
                return "success"
             case "Active":
                return "success" 
            case "Paid":
                return "success"  
                
                
            default:
              return ""
         }
      },
        FULLNAME(profile){
          if(profile.lastname == "") {
            return profile.firstname
          }
        
          return profile.lastname +', '+ profile.firstname
        },
  TEXT_COLOR(status){
         switch(status) {
            case "Cancelled":
              return "text-error"
            case "Pending":
              return "text-warning"
              case "Completed":
                  return "text-success"
              case "Active", "paid":  
                return "text-success"
             case "In Progress":
                return "text-info" 
            case "Paid":
                return "success"   
           case "Job Order", "pending":
                return "text-warning" 
           case "Installment":
                return "text-indigo" 
            case "Rental":
                return "text-accent"
             case "Standard":
                return "text-info"
    case "Active":
                return "text-success"
            default:
              return ""
         }
      },
      STATUS_BG(status){
         switch(status) {
            case "Available":
              return "bg-success"
            case "Pending":
              return "bg-warning"
              case "Completed", "Active":
                return "bg-success"
            case "Cancelled":
                return "bg-cancelled"
             case "Paid":
                return "bg-success" 
              case "Requested":
                return "bg-info"
              case "Delivered":
                return "bg-success" 
              case "Approved":
                return "bg-accent"              
            default:
              return "bg-info"
         }
      },
      ClearSnackbar(timeout){
          setTimeout(() =>{
            this.setActionAlert({show: false})
          }, timeout)
      },
       ImagePreview(images){
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
      ViewUploadedfiles(uploadedfiles){
        var preview = []
        const imageRegExp = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
        for (const file of uploadedfiles) {
            if(imageRegExp.test(file)){
              preview.push(file)
            } else {
              preview.push(this.$store.state.nopreview)
            }
        }
        return preview
      },
      FieldRules(ruleMsg){
        return [
          v => !!v || ruleMsg,
        ];
      },
      
       DownloadToCsv (eleID, filename) {
        const dataTable = document.getElementById(eleID)
        const exporter = new TableCSVExporter(dataTable)
        const csvOutput = exporter.convertToCSV()
        const csvBlob = new Blob([csvOutput], { type: 'text/csv' })
        const blobUrl = URL.createObjectURL(csvBlob)
        const anchorElement = document.createElement('a')
  
        anchorElement.href = blobUrl
        anchorElement.download =  filename+ '.csv'
        anchorElement.click()
  
        setTimeout(() => {
          URL.revokeObjectURL(blobUrl)
        }, 500)
      }
    } ///eof methods
}